import React from "react";
import CreateNode from "@Common/CreateNode";
import { RadioButton } from "primereact/radiobutton";
import "./style.scss";

const RadioButtonUI = ({ addClass = "", label = "", onChange = () => {}, radioData = [], value = "", setData = () => {}, setDataMulti = () => {}, changeableData = [], disabled = false }) => {
    return (
        <div className={"detail__item radio " + addClass}>
            <label className={"radio__label"}>{label}</label>
            <div className={`radio__container`}>
                {radioData.map((item, idx) => {
                    return (
                        <div className="radio__item" key={idx}>
                            <div className="radio__checkradio">
                                <RadioButton id={item.id} value={item.value} onChange={onChange} checked={value === item.value} disabled={disabled} />
                                <label>{item.label}</label>
                            </div>
                            {item.radioNode ? <CreateNode item={item.radioNode} value={value} setData={setData} setDataMulti={setDataMulti} changeableData={changeableData} /> : null}
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default RadioButtonUI;
